module.exports = __webpack_public_path__ + "static/media/5.8691dbe8.png";